import styled from "styled-components";

export const Header = styled.div`
  width: 100%;
  /* background-color: #141e29; */
  padding-top: 1rem;
`;
export const Title = styled.h4`
  font-size: 24px;
  font-weight: 500;

  @media (max-width: 525px) {
    font-size: 16px;
    margin-bottom: 0.1rem;
  }
`;
export const SmallTitle = styled.p`
  font-size: 20px;
  font-weight: 400;
  margin-bottom: 0.5rem;

  @media (max-width: 525px) {
    font-size: 16px;
    font-weight: 300;
  }
`;
export const PLanHeader = styled.div`
  padding: 1rem;
  width: 90%;
  max-width: 552px;
  background-color: #232323;
  text-align: left;
  margin: 30px auto;
  span {
    font-size: 16px;
    font-weight: bold;
  }
`;
export const PlanContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 1.3rem;

  @media (max-width: 575.99px) {
    gap: 8px;
  }
`;
export const SinglePlan = styled.div`
  width: 90vw;
  max-width: 552px;
  min-height: 162px;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 3px 6px 0px rgba(0, 0, 0, 0.75);
  -webkit-box-shadow: 0 3px 6px 0px rgba(0, 0, 0, 0.75);
  display: flex;
  color: #000f1e;
  .left {
    width: 60px;
    background-color: ${(props) => props.color};
    min-height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    border-right: 1.5px dashed #222;
    span {
      transform: rotate(-90deg);
      font-size: 18px;
      font-weight: 600;
      letter-spacing: 2px;
      text-transform: uppercase;
    }
  }
  header {
    display: flex;
    gap: 2rem;
    align-items: center;
    .icon-logo {
      height: 40px;
      width: 40px;
      object-fit: contain;
    }
    @media (max-width: 500px) {
      gap: 0.6rem;
      img {
        height: 38px;
        width: 38px;
      }
    }
  }
  .right {
    padding: 1rem;
    width: 100%;
  }
`;

export const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
`;
export const List = styled.div`
  display: flex;
  align-items: center;
  gap: 0.7rem;
  color: #222;
  @media (max-width: 500px) {
    gap: 0.3rem;
  }
  svg {
    font-size: 10px;
    font-weight: 300;
    @media (max-width: 500px) {
      font-size: 8px;
    }
  }
  span {
    font-size: 12px;
    font-weight: 700;
    @media (max-width: 500px) {
      font-size: 10px;
      font-weight: 700;
    }
  }
`;
export const Bottom = styled.div`
  margin-top: 1.2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .price {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0;
  }
  .price-text {
    font-size: 14px;
    color: #6d6d6d;
    font-weight: 700;
    margin: 0;
  }
  .currency {
    font-size: 24px;
    font-weight: 700;
    margin: 0;
    color: #6d6d6d !important;
    line-height: 1;
    display: flex;
    align-items: flex-end;

    .price-unit {
      display: flex;
      gap: 5px;
    }

    @media (max-width: 500px) {
      font-size: 16px;
      flex-direction: column;
      align-items: flex-start;
    }
    @media (max-width: 360px) {
      font-size: 14px;
      flex-direction: column;
    }
  }
  .price-additional {
    margin-left: 16px;
    font-size: 12px;
    letter-spacing: 0.5px;
    font-weight: 400;
    width: 69%;
    text-align: left;
    @media (max-width: 600px) {
      margin-top: 5px;
      font-size: 9px;
      margin-left: 0px;
      display: inline-block;
      letter-spacing: 0.1px;
      width: auto;
    }
  }
  .buy-btn {
    /* background-color: #e30061; */
    color: #fff;
    border-radius: 99px;
    transition: 0.2s ease-in;
    display: inline-block;
    width: 102px;

    :hover {
      transform: scale(1.05);
    }
    @media (max-width: 500px) {
      font-size: 12px;
    }
    @media (max-width: 360px) {
      font-size: 10px;
      padding: 6px 8px;
    }
  }
`;
